namespace RedBullMOBILE360.CustomerCare {
    export interface ThreeThreeZeroNotificationRow {
        Id?: number;
        Tcn?: string;
        PersonId?: string;
        TypeOfComplaint?: string;
        NotificationCounter?: number;
        ReportedIdentity?: string;
        ReporterList?: string;
        OperatorTcn?: string;
        ReportDate?: string;
        Status?: string;
        FirstActionDate?: string;
        SecondActionDate?: string;
        ActionType?: Web.Modules.Common.ActionType;
        UserCurrentStatus?: Web.Modules.Common.SubStatus;
        ActionDate?: string;
        PrimaryOffer?: string;
        UserPrimaryOfferId?: string;
        ActivationDate?: string;
        NotificationSource?: Web.Modules.Common.Helpers.NotificationSource;
        SimType?: string;
        ExtraActionPeriodDays?: number;
    }

    export namespace ThreeThreeZeroNotificationRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Tcn';
        export const localTextPrefix = 'CustomerCare.ThreeThreeZeroNotification';
        export const deletePermission = 'CustomerCare:ThreeThreeZeroNotification';
        export const insertPermission = 'CustomerCare:ThreeThreeZeroNotification';
        export const readPermission = 'CustomerCare:ThreeThreeZeroNotification';
        export const updatePermission = 'CustomerCare:ThreeThreeZeroNotification';

        export declare const enum Fields {
            Id = "Id",
            Tcn = "Tcn",
            PersonId = "PersonId",
            TypeOfComplaint = "TypeOfComplaint",
            NotificationCounter = "NotificationCounter",
            ReportedIdentity = "ReportedIdentity",
            ReporterList = "ReporterList",
            OperatorTcn = "OperatorTcn",
            ReportDate = "ReportDate",
            Status = "Status",
            FirstActionDate = "FirstActionDate",
            SecondActionDate = "SecondActionDate",
            ActionType = "ActionType",
            UserCurrentStatus = "UserCurrentStatus",
            ActionDate = "ActionDate",
            PrimaryOffer = "PrimaryOffer",
            UserPrimaryOfferId = "UserPrimaryOfferId",
            ActivationDate = "ActivationDate",
            NotificationSource = "NotificationSource",
            SimType = "SimType",
            ExtraActionPeriodDays = "ExtraActionPeriodDays"
        }
    }
}
